{
  "title": "Magic Circle",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level abjuration",
  "level": 3,
  "castingTime": "1 minute",
  "range": "10 feet",
  "components": "V, S, M (holy water or powdered silver and iron worth at least 100 gp, which the spell consumes)",
  "duration": "1 hour",
  "description": [
    "You create a 10-foot-radius, 20-foot-tall cylinder of magical energy centered on a point on the ground that you can see within range. Glowing runes appear wherever the cylinder intersects with the floor or other surface.",
    "Choose one or more of the following types of creatures: celestials, elementals, fey, fiends, or undead. The circle affects a creature of the chosen type in the following ways:",
    "The creature can’t willingly enter the cylinder by nonmagical means. If the creature tries to use teleportation or interplanar travel to do so, it must first succeed on a Charisma saving throw.",
    "The creature has disadvantage on attack rolls against targets within the cylinder.",
    "Targets within the cylinder can’t be charmed, frightened, or possessed by the creature.",
    "When you cast this spell, you can elect to cause its magic to operate in the reverse direction, preventing a creature of the specified type from leaving the cylinder and protecting targets outside it.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the duration increases by 1 hour for each slot level above 3rd."
  ],
  "spellLists": ["cleric", "eldritch-knight", "paladin", "warlock", "wizard"]
}
